<template>
	<div class="db2-palette">
		<div class="db2-palette-title">Add components</div>
		<button
			type="button"
			class="db2-palette-item is-section"
			@click="addSection"
		>
			<v-icon>mdi-view-agenda-outline</v-icon>
			<span>Section</span>
		</button>
		<button
			v-for="t in types"
			:key="t.type"
			type="button"
			class="db2-palette-item"
			:class="{ 'is-disabled': t.disabled }"
			:disabled="!!t.disabled"
			:title="t.disabled ? 'Coming soon' : undefined"
			@mousedown="onDown(t, $event)"
		>
			<v-icon>{{ t.icon }}</v-icon>
			<span>{{ t.label }}</span>
		</button>
		<v-switch
			class="db2-show-grid"
			v-model="gridOn"
			:true-value="true"
			:false-value="false"
			label="Show grid"
			hide-details
			dense
			color="primary"
		/>
	</div>
</template>

<script>
import { CARD_TYPES } from './dashboardModel';

/**
 * Edit-mode component palette and show-grid toggle.
 */
export default {
	name: 'CardPalette',
	props: {
		showGrid: { type: Boolean, default: true }
	},
	data() {
		return { types: CARD_TYPES };
	},
	computed: {
		/**
		 * Strict boolean for v-switch so is-grid never sees a string or event.
		 * @returns {boolean}
		 */
		gridOn: {
			get() {
				return this.showGrid === true;
			},
			set(val) {
				this.$emit('update:showGrid', val === true);
			}
		}
	},
	methods: {
		/**
		 * Start a click-or-drag add from the palette.
		 * @param {{ type: string, disabled?: boolean, icon?: string, label?: string }} t
		 * @param {MouseEvent} e
		 */
		onDown(t, e) {
			if (t.disabled) return;
			if (e.button !== 0) return;
			e.preventDefault();
			this.$emit('palette-down', { type: t.type, event: e });
		},
		/**
		 * Add a section from the palette.
		 * @param {MouseEvent} e
		 */
		addSection(e) {
			if (e && e.currentTarget && e.currentTarget.blur) e.currentTarget.blur();
			this.$emit('add-section');
		}
	}
};
</script>
